import React from "react"
import { styled } from "@mui/material/styles"
import ArrowRight from "assets/images/buttons/ArrowRight.svg"

const StyledImg = styled("img")({
  width: "15px",
  height: "15px",
  verticalAlign: "middle",
})

const TopLinkCardArrow = () => {
  return <StyledImg src={ArrowRight} alt="arrowIcon" />
}

export default TopLinkCardArrow
